"use client";

import { Flex } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

export function formatSidebarNavCountBadge(count: number): string | null {
  if (count <= 0) return null;
  return count > 9 ? "9+" : String(count);
}

type SidebarNavCountBadgeProps = {
  count: number;
  variant?: "inline" | "overlay";
  "data-testid"?: string;
};

export function SidebarNavCountBadge({
  count,
  variant = "inline",
  "data-testid": dataTestId,
}: SidebarNavCountBadgeProps) {
  const theme = useThemeTokens();
  const label = formatSidebarNavCountBadge(count);

  if (!label) return null;

  const isOverlay = variant === "overlay";
  const badgeBg = theme.accent.primary;

  return (
    <Flex
      as="span"
      data-testid={dataTestId}
      ml={isOverlay ? undefined : "auto"}
      flexShrink={0}
      align="center"
      justify="center"
      minW={isOverlay ? "16px" : "20px"}
      h={isOverlay ? "16px" : "20px"}
      px={count > 9 ? (isOverlay ? 1 : 1.5) : 0}
      borderRadius="full"
      bg={badgeBg}
      color="white"
      fontSize={isOverlay ? "9px" : "10px"}
      fontWeight="700"
      lineHeight="1"
      position={isOverlay ? "absolute" : "relative"}
      top={isOverlay ? "-5px" : undefined}
      right={isOverlay ? "-7px" : undefined}
      boxShadow={isOverlay ? "0 2px 6px rgba(0,0,0,0.25)" : undefined}
      borderWidth={isOverlay ? "2px" : undefined}
      borderColor={isOverlay ? theme.surfaceGlass.sidebar : undefined}
      zIndex={isOverlay ? 1 : undefined}
    >
      {label}
    </Flex>
  );
}
